import { styled } from '@styledComponents';
import { JoykitIcon } from '@components/JoykitIcon';
import { Button } from '@components/Button';
import { Flex } from '@components/Flex';
import { Columns } from '@components/Columns';
import Modal from 'react-modal';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { BaseImage } from '@components/CloudImage';
import { animationTransition } from '@utils/animationTransition';

export const CARD_WIDTH_MOBILE = 100;
export const CARD_HEIGHT_MOBILE = 150;
export const CARD_OFFSET_MOBILE = 20;
export const GAP_SIZE_MOBILE = 15;
export const CARD_WIDTH_DESKTOP = 300;
export const CARD_HEIGHT_DESKTOP = 450;
export const CARD_OFFSET_DESKTOP = 80;
export const GAP_SIZE_DESKTOP = 70;

const isImageSquarish = (aspectRatio: number) => {
  return aspectRatio >= 0.9 && aspectRatio <= 1.1;
};

export const StyledModal = styled(Modal)`
  background-color: transparent;
  border: none;
  overflow: visible;
  margin: auto;
  width: 63%;

  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  ${themeMediaQuery('sm')} {
    width: 100%;
  }
  ${themeMediaQuery('md')} {
    width: 96%;
  }
  @media (min-width: 1400px) {
    width: 82%;
  }
  ${themeMediaQuery('lg')} {
    width: 80%;
  }
  ${themeMediaQuery('xl')} {
    width: 67%;
  }
  @media (min-width: 1920px) {
    width: 63%;
  }
`;

export const StyledColumns = styled(Columns)`
  background: white;
  min-height: 500px;
  border-radius: ${themeSpace(4)};
  padding: ${themeSpace(8)} ${themeSpace(5)};
  position: relative;
  margin-left: 0;
  margin-right: 0;
  ${themeMediaQuery('below_sm')} {
    margin: auto;
    padding: ${themeSpace(4)} ${themeSpace(3)};
    border-radius: 0px;
  }
  ${themeMediaQuery('sm')} {
    max-width: 60rem;
  }
  ${themeMediaQuery('md')} {
    max-width: 70rem;
  }
  ${themeMediaQuery('xl')} {
    max-width: 75rem;
  }
`;

export const StyledCloseButton = styled(Button)`
  position: absolute;
  top: -30px;
  right: -10px;
  padding: ${themeSpace(3)};
  background: none;
  border: none;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: ${themeSpace(4)};
  display: flex;
  align-items: center;
  justify-content: center;
  :focus {
    outline: none;
  }
  ${themeMediaQuery('below_sm')} {
    top: -24px;
    right: -15px;
  }
`;

export const StyledInnerContainer = styled(Flex)`
  width: 100%;
  height: 100%;
`;

export const ECardImageContainer = styled.div`
  position: relative;
`;

export const ECardImageWrapper = styled.div<{ aspectRatio: number }>`
  position: relative;
  width: ${({ aspectRatio }) => (isImageSquarish(aspectRatio) ? '100%' : aspectRatio > 1 ? '100%' : 'unset')};
  height: ${({ aspectRatio }) => (isImageSquarish(aspectRatio) ? '100%' : aspectRatio < 1 ? '100%' : 'unset')};
  transition: ${animationTransition('transform')};
  box-shadow: 0px 30px 60px -12px rgba(44, 41, 37, 0.25), 0px 18px 36px -18px rgba(0, 0, 0, 0.3);
  border-radius: ${themeSpace(2)};
  ${themeMediaQuery('sm')} {
    transform: scale(1.001);
  }
`;

export const ECardImage = styled(BaseImage)<{ isLoaded: boolean }>`
  margin: auto;
  height: 225px;
  display: block;
  transition: ${animationTransition('box-shadow')};
  visibility: ${({ isLoaded }) => (isLoaded ? 'visible' : 'hidden')};
  border-radius: ${themeSpace(3)} ${themeSpace(3)};
  ${themeMediaQuery('sm')} {
    margin: initial;
    height: 400px;
  }
  ${themeMediaQuery('md')} {
    height: 514px;
  }
`;

export const StyledCloseIcon = styled(JoykitIcon)`
  width: 16px;
  height: 16px;
  ${themeMediaQuery('below_sm')} {
    width: 12px;
    height: 12px;
  }
`;

export const StyledThemeJoykitIcon = styled(JoykitIcon)`
  width: 18px;
  height: 18px;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  max-width: 323px;
  ${themeMediaQuery('below_sm')} {
    max-width: 350px;
    width: 100%;
  }
`;

export const TextColumnWrapper = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    align-items: center;
  }
`;

export const RightFlex = styled(Flex)`
  width: 100%;
  justify-content: flex-end;
  ${themeMediaQuery('below_sm')} {
    align-items: center;
  }
  ${themeMediaQuery('sm')} {
    margin-top: ${themeSpace(6)};
  }
`;

export const LeftFlex = styled(Flex)`
  position: relative;
`;

export const CardTitleMobileWrapper = styled(Flex)`
  max-width: 80%;
  text-align: center;
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const CardTitleDesktopWrapper = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StartWithMobileButtonWrapper = styled(Flex)`
  width: 100%;
  position: fixed;
  bottom: 0;
  box-shadow: 0px -1px 0px #ebebeb;
  background: #ffffff;
  padding: ${themeSpace(5)};
  justify-content: center;
  max-width: 35.75rem;
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const StartWithDesktopButtonWrapper = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const CloseButtonMobileWrapper = styled(Flex)`
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const CloseButtonDesktopWrapper = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;
